import React from "react";
import ServiceDetailPage from "./ServiceDetailPage";

export const FinancialPage = () => (
  <ServiceDetailPage
    slug="financial"
    heroImage="https://images.pexels.com/photos/7821671/pexels-photo-7821671.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
    heroSubtitle="Coordinated financial planning support for individuals, families, and business owners building long-term stability."
    longDescription="Our financial services begin with listening - understanding your goals, your current situation, and the responsibilities you carry. From there, we help you organize, plan, and coordinate with the right professionals so that retirement, investment, and family financial planning all work together."
  />
);

export const TaxPage = () => (
  <ServiceDetailPage
    slug="tax"
    heroImage="https://images.unsplash.com/photo-1554224155-6726b3ff858f?auto=format&fit=crop&w=2000&q=80"
    heroSubtitle="Accurate, year-round tax support for individuals, self-employed professionals, and small businesses across the United States."
    longDescription="Tax planning is most effective when it is continuous. We coordinate individual and business tax preparation, support during IRS notices, and year-round planning for self-employed and small business clients. Our approach focuses on clarity, accuracy, and timely communication."
  />
);

export const InsurancePage = () => (
  <ServiceDetailPage
    slug="insurance"
    heroImage="https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&w=2000&q=80"
    heroSubtitle="Coordinated insurance reviews for life, health, home, auto, and business coverage - so the pieces actually fit together."
    longDescription="Our insurance review service helps you understand your current coverage, identify gaps, and coordinate with the right carriers for life, health, home, auto, and business insurance. The goal is appropriate protection - not over-insurance and not dangerous gaps."
  />
);

export const LegalPage = () => (
  <ServiceDetailPage
    slug="legal"
    heroImage="https://images.unsplash.com/photo-1589216532372-1c2a367900d9?auto=format&fit=crop&w=2000&q=80"
    heroSubtitle="Legal service coordination for personal, family, and business matters - delivered through qualified legal professionals where required."
    longDescription="We coordinate legal support for wills and trusts, estate planning, probate, business documentation, immigration, and asset protection. Our role is to help you organize, prepare, and connect with appropriate licensed legal professionals."
    complianceNote="HSA Service Hub provides legal service coordination and support, not legal advice. Legal services are delivered through qualified, licensed legal professionals where required. Please consult a licensed attorney for advice specific to your situation."
  />
);

export const BusinessPage = () => (
  <ServiceDetailPage
    slug="business"
    heroImage="https://images.unsplash.com/photo-1638262052640-82e94d64664a?auto=format&fit=crop&w=2000&q=80"
    heroSubtitle="One-stop coordinated support for small business owners and entrepreneurs - tax, insurance, financial planning, and legal documentation."
    longDescription="Running a business is demanding enough without juggling separate vendors for every responsibility. Our business services bring tax filing, insurance review, financial planning, and legal documentation coordination together so you can focus on growth, compliance, and protection at the same time."
  />
);
